import { render, staticRenderFns } from "./MigrationDetailsCard.vue?vue&type=template&id=743d1c4e&"
import script from "./MigrationDetailsCard.vue?vue&type=script&lang=js&"
export * from "./MigrationDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('743d1c4e')) {
      api.createRecord('743d1c4e', component.options)
    } else {
      api.reload('743d1c4e', component.options)
    }
    module.hot.accept("./MigrationDetailsCard.vue?vue&type=template&id=743d1c4e&", function () {
      api.rerender('743d1c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Migrations/MigrationDetailsCard.vue"
export default component.exports